import { ProductType as CourseType } from "@/common/course/types";
import { ProgramType } from "@/common/program/types";
import { productIconListKeys } from "../../shared/productCardListMessages";

export const productTypes = [
  CourseType.COURSE,
  CourseType.EXECUTIVE_EDUCATION,
  ProgramType.MASTERS,
  ProgramType.BACHELORS,
];

export const productTypeIconList = productIconListKeys;
